import {
  type AnyAction,
  type Middleware,
  type MiddlewareAPI,
  type ThunkDispatch,
} from '@reduxjs/toolkit';
import {
  mapper
} from '@shared/lib';
import {
  setAppVersion,
  setOpenOutdatedAppVersionModal,
  checkAppVersionSlice,
  type CheckAppVersionState,
} from '../model';

type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;
type RootState = { [checkAppVersionSlice.name]: CheckAppVersionState };

type AppVersionError = {
  status: number;
  expectedVersion: string;
  receivedVersion: Maybe<string>;
};

type MapToAppVersionError = (data: unknown) => AppVersionError;
const mapToAppVersionError: MapToAppVersionError = mapper([
  {
    name: 'status',
    from: 'payload.data.error.status',
  },
  {
    name: 'expectedVersion',
    from: 'payload.data.error.details.expectedVersion',
  },
  {
    name: 'receivedVersion',
    from: 'payload.data.error.details.receivedVersion',
  },
]);

export const handleAppVersionRejectionMiddleware: Middleware = (store: MiddlewareAPI<AppDispatch, RootState>) => next => action => {
  const appVersionError = mapToAppVersionError(action);
  const isRejectedAction = (action as AnyAction).type.endsWith('api/executeQuery/rejected');

  if (isRejectedAction && appVersionError?.status === 426) {
    store.dispatch(setAppVersion(appVersionError?.expectedVersion));
    store.dispatch(setOpenOutdatedAppVersionModal(true));
    return null;
  }

  return next(action);
};